<template>
  <v-app :style="settingBackGroundColor()">
    <v-app-bar v-if="$root.isLogin" app dense >
      <v-app-bar-nav-icon v-if="$root.isSupporterMenu" @click.stop="drawer = !drawer">
        <v-icon color="accent">mdi-menu</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>{{ this.$root.siteName }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="ma-2" dark @click="this.toProfileSetting">
        設定
      </v-btn>
    </v-app-bar>

    <!-- サポート担当者メニュー -->
    <v-navigation-drawer v-if="$root.isSupporterMenu" v-model="drawer" fixed temporary>
      <v-list>
        <v-list-item v-for="item in items" :key="item.id" link>
          <v-list-item-content @click="item.action">
            <v-list-item-title>
              <v-icon>{{ item.icon }}</v-icon>
              {{ item.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ item.text }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <router-view />
    </v-main>

    <!-- 顧客担当者メニュー -->
    <v-bottom-navigation
      v-if="$root.isCustomerMenu"
      color="accent"
      v-model="isActive"
      app
      grow
    >
      <v-btn value="menu01" @click="this.toCustomerTopPage">
        <span class="text-button">依頼状況一覧</span>
        <v-icon>mdi-clipboard-check-multiple-outline</v-icon>
      </v-btn>
      <v-btn value="menu02" @click="this.toSupportRequestRegist">
        <span class="text-button">依頼登録</span>
        <v-icon>mdi-clipboard-edit-outline</v-icon>
      </v-btn>
    </v-bottom-navigation>

    <!-- サポート担当者メニュー -->
    <v-bottom-navigation
      v-if="$root.isSupporterMenu"
      color="accent"
      v-model="isActive"
      app
      grow
    >
      <v-btn value="menu01" @click="this.toSupporterTopPage">
        <span class="text-button">本日状況</span>
        <v-icon>mdi-account-settings-outline</v-icon>
      </v-btn>
    </v-bottom-navigation>

    <Loading
      :active.sync="$root.loading"
      :can-cancel="false"
      :is-full-page="true"
    ></Loading>
  </v-app>
</template>

<script>
//import { format } from 'date-fns';
//import { ja } from 'date-fns/locale';
export default {
  data() {
    return {
      isActive: 'menu01',
      drawer: false,
      items: [
        // サポート担当者メニュー
        {
          id: 0,
          icon: "mdi-clipboard-edit-outline",
          name: "起票",
          text: "電話起票・作業報告書登録",
          action: this.toCustomerSelect,
        },
        {
          id: 1,
          icon: "mdi-clipboard-check-multiple-outline",
          name: "担当課題一覧",
          action: this.toIssueList,
        },
        {
          id: 2,
          icon: "mdi-account-group",
          name: "顧客管理",
          text: "登録・編集やメンバー割当",
          action: this.toCustomerList,
        },
      ],
    };
  },
  // 初期表示時データ読み込み
  async created() {
    // ログイン済フラグ
    this.$root.isLogin = false;
    // ローディングフラグ
    this.$root.loading = false;
    // 顧客担当者メニュー表示フラグ
    this.$root.isCustomerMenu = false;
    // サポート担当者メニュー表示フラグ
    this.$root.isSupporterMenu = false;
    // タイトルバーの学校名
    this.$root.siteName = "";
    // アップロード先バケットパス
    this.$root.uploadPath = "";

    // ログイン画面初期表示
    console.log("Vue初期化処理(画面ソース読込)");
    const conds = ['PasswordReset'];
    if (!conds.includes(this.$router.currentRoute.name)) {
      this.$router.push({
        name: "Login",
      });
    }
  },
  methods: {
    settingBackGroundColor() {
      switch (this.$root.userKbn) {
        case "0":
          return "{background-repeat: no-repeat;background-image: linear-gradient(rgb(77, 171, 255),rgb(193, 217, 255));}"
        case "8":
          return "{background-repeat: no-repeat;background-image: linear-gradient(rgb(255, 77, 77),rgb(255, 203, 203));}"
        default:
          return "{background-repeat: no-repeat;background-image: linear-gradient(rgb(77, 171, 255),rgb(193, 217, 255));}"
      }
    },
    // ヘッダーメニュー ---------------------------------------------------------------------------- //
    // プロフィール設定画面
    toProfileSetting() {
      this.isActive = undefined;
      this.$router.push({
        name: "ProfileSetting",
      });
    },
    // フッターメニュー(顧客担当者用) ---------------------------------------------------------------------------- //
    // トップページ画面(顧客担当者用)
    toCustomerTopPage() {
      this.$router.push({
        name: "CustomerTopPage",
      });
    },
    toSupportRequestRegist() {
      this.$router.push({
        name: "SupportRequestRegist",
      });
    },

    // フッターメニュー(サポート担当者用) ---------------------------------------------------------------------------- //
    // トップページ画面(サポート担当者用)
    toSupporterTopPage() {
      this.$router.push({
        name: "SupporterTopPage",
      });
    },

    // サイドメニュー(サポート担当用) ---------------------------------------------------------------------------- //
    // 顧客選択
    toCustomerSelect() {
      this.isActive = undefined;
      this.$router.push({
        name: "CustomerSelect",
      });
    },

    // 担当問い合わせ一覧
    toIssueList() {
      this.isActive = undefined;
      this.$router.push({
        name: "IssueList",
      });
    },
    // 顧客一覧画面
    toCustomerList() {
      this.isActive = undefined;
      this.$router.push({
        name: "CustomerList",
      });
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=M+PLUS+Rounded+1c:wght@500&display=swap');
#app {
  font-family: 'M PLUS Rounded 1c', sans-serif;
}
</style>